/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Vast_Wren_NestInputs */

const en_swift_vast_wren_nest = /** @type {(inputs: Swift_Vast_Wren_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Manager`)
};

const de_swift_vast_wren_nest = /** @type {(inputs: Swift_Vast_Wren_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add Manager" |
*
* @param {Swift_Vast_Wren_NestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_vast_wren_nest = /** @type {((inputs?: Swift_Vast_Wren_NestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Vast_Wren_NestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_vast_wren_nest(inputs)
	return de_swift_vast_wren_nest(inputs)
});